import React from 'react';
import { FaucetElevation } from './FaucetElevation';
import {
  tubFaucetProfile,
  resolveTubFaucetVariant,
} from '../../3d/geometry/proceduralRenderers/proceduralSpecs';

/**
 * Tub faucet elevation. Variants (`resolveTubFaucetVariant`, shared with the
 * 3D renderer): deck-mount (default, Roman filler), wall-mount, floor-mount
 * (freestanding filler column) — from `obj.faucetMountType`
 * ('deck' | 'wall' | 'floor', what `placeTub` stamps), `obj.wallMounted`, or
 * the older `mountType` / `subtype` / `style`. Drawn by `FaucetElevation`
 * over `tubFaucetProfile`.
 */
export { resolveTubFaucetVariant };

export function BathroomTubFaucetSchematic({
  widthMeters,
  heightMeters,
  depthMeters,
  obj = {},
  strokeColor,
  strokeWidth,
  view = 'front',
}) {
  const dims = { width: widthMeters, height: heightMeters, depth: depthMeters };
  const profile = tubFaucetProfile(dims, resolveTubFaucetVariant(obj));
  return (
    <FaucetElevation
      profile={profile}
      view={view}
      widthMeters={widthMeters}
      heightMeters={heightMeters}
      depthMeters={depthMeters}
      strokeColor={strokeColor}
      strokeWidth={strokeWidth}
    />
  );
}

BathroomTubFaucetSchematic.supportsSideViews = true;
